"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.MiscAddonStore = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _take2 = _interopRequireDefault(require("lodash/take"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _misc = require("../clients/misc.client");
var _class, _descriptor, _descriptor2, _descriptor3;
let MiscAddonStore = (_class = /*#__PURE__*/function () {
  function MiscAddonStore(initialState = {}) {
    (0, _classCallCheck2.default)(this, MiscAddonStore);
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "API_STATE", _descriptor2, this);
    this.orderNumber = void 0;
    (0, _initializerDefineProperty2.default)(this, "fetch", _descriptor3, this);
    this.updateInitialState(initialState);
  }
  (0, _createClass2.default)(MiscAddonStore, [{
    key: "isLoading",
    get: function () {
      return this.API_STATE === _constants.API_STATE.LOADING;
    }
  }, {
    key: "isFetched",
    get: function () {
      return this.API_STATE === _constants.API_STATE.SUCCESS;
    }
  }, {
    key: "hasError",
    get: function () {
      return this.API_STATE === _constants.API_STATE.FAILED;
    }
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(data) {
      this.data = data;
      this.API_STATE = _constants.API_STATE.SUCCESS;
    }
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      errorHandler(error);
      this.API_STATE = _constants.API_STATE.FAILED;
    }
  }, {
    key: "miscellaneousList",
    get: function () {
      const miscList = (0, _get2.default)(this.data, 'miscellaneousList', []);
      const filterListType = miscList !== null && miscList !== void 0 && miscList.length ? miscList.filter(item => {
        var _item$prices, _item$prices$;
        return ((_item$prices = item.prices) === null || _item$prices === void 0 ? void 0 : (_item$prices$ = _item$prices[0]) === null || _item$prices$ === void 0 ? void 0 : _item$prices$.showType) === 'fixed' && item.selectionType === 'booking';
      }) : [];
      const miscListFirstFour = (0, _take2.default)(filterListType, 4);
      return miscListFirstFour;
    }
  }]);
  return MiscAddonStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return _constants.API_STATE.INITIAL;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fetch", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* ({
      payload,
      id,
      errorHandler
    }) {
      this.API_STATE = _constants.API_STATE.LOADING;
      try {
        const response = yield _misc.MiscClient.fetch(payload, id);
        this.onSuccess(response);
        this.orderNumber = payload.order.orderNumber;
      } catch (error) {
        this.onError(error, errorHandler);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "miscellaneousList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "miscellaneousList"), _class.prototype)), _class);
exports.MiscAddonStore = MiscAddonStore;